import { Text, View } from '@react-pdf/renderer';

export default function DisclaimerBlock() {
    return (
        <View>
            <Text style={{fontSize:"5px"}}>
                "Cotización en pesos mexicanos, sujeta a cambio sin previo aviso, debido al comportamiento del mercado o tipo de cambio, precio del vehículo ya incluye el ISAN.
                *El seguro es contratado por conducto de "Peicar" (Conduce Capital S.A. de C.V.) y pagado por el cliente, el seguro estará vigente por el plazo total del arrendamiento.
                *El cliente es el responsable, del costo del mantenimiento, verificación vehicular y conservación adecuada del vehículo, así como de los costos en los que incurra ante cualquier autoridad.
                *Al término del arrendamiento, el valor residual de venta  (Balloon) que viene en el apartado ""III.- Valor Residual del Equipo"" será respetado al fin del contrato siempre y cuando no se exceda de 30 días naturales después del último pago del arrendamiento.
                *El costo del trámite vehicular está sujeto a cambio si el pago inicial no fuere realizado en el mes de dicha cotización.
                *La fecha de corte es informativa, puede variar con base al inicio del pago inicial del arrendamiento.
                *Una vez aceptada, confirmada y realizado el pago inicial de dicha cotización, NO se podrá cancelar la operación, solo se podrá liquidar anticipadamente después del 6° mes con base a la tabla de pagos.
                *Sujeto a Aprobación del Arrendamiento."
            </Text>
        </View>
    )
}
